<template>
    <div class="loader loader-100vh" v-if="this.$root.isLoading()">
        <center><i class="fas fa-spinner fa-3x rotate"  @click="$ss.loading = false;"></i></center>
    </div>
    
</template>

<script>
export default {
    name : 'LoadMask'   
}
</script>


<style scoped>

    .rotate{
        -webkit-animation: rotation 500ms infinite linear;
        animation: rotation 500ms infinite linear;
        color: var(--dark-color);
    }

    @keyframes rotation {
        
        from {transform: rotate(0deg);}
        to   {transform: rotate(359deg);}
    }

    @-webkit-keyframes rotation{
        from {-webkit-transform: rotate(0deg);}
        to   {-webkit-transform: rotate(359deg);}
    }

    .loader-100vh{
        line-height: 100vh;
        z-index: 20;
        position: fixed;
    }



</style>
